var map = {
	"./baoku/baoku_banner.jpg": 628,
	"./common/arrow/icon_arrow_left_black.png": 774,
	"./common/arrow/icon_arrow_left_gray.png": 423,
	"./common/arrow/icon_arrow_left_gray_60.png": 223,
	"./default/default_f7f7f7_book_cover.png": 934
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 990;